import easyfyAxios from '@shared/easyfy.axios';

export interface CreditCardRequest {
  orderNumber?: string;
  checkoutId?: string;
  cardNumber: string;
  validDate: string;
}

export const CreditCard = async (): Promise<any> => {
  return await easyfyAxios.get(`/api/ageverification?handler=creditCard`);
};

export const DataMatch = async (orderNr: string, checkoutid: string): Promise<any> => {
  return await easyfyAxios.get(`/api/ageverification?handler=dataMatch&orderNr=${orderNr}&checkoutId=${checkoutid}&?n=${new Date().getTime()}`);
};

export const CreditCardVerify = async (creditCardRequest: CreditCardRequest, token: string): Promise<any> => {
  return await easyfyAxios.post(`/api/ageverification?handler=creditCard`, creditCardRequest, token);
};

export const IDCardVerify = async (orderNumber: string): Promise<any> => {
  return await easyfyAxios.get(`/api/ageverification?handler=idCardVerify&orderNumber=${orderNumber}&n=${new Date().getTime()}`);
};

export const GetIDCardResponse = async (ageCheckedCookie: string, ageCheckId: string, token: string): Promise<any> => {
  return await easyfyAxios.post(
    `/age-verification/id-card-response?handler=idCardResponse&n=${new Date().getTime()}`,
    { ageCheckedCookie: ageCheckedCookie, ageCheckId: ageCheckId },
    token
  );
};

export const GetEmptyPage = async (): Promise<any> => {
  return await easyfyAxios.get(`/api/ageverification?handler=empty`);
};

export const GetYotiCallbackResult = async (avCookie: string, sessionId: string, token: string): Promise<any> => {
  return await easyfyAxios.post(
    `/age-verification/yoti-response?handler=callbackResponse&n=${new Date().getTime()}`,
    { cookieString: avCookie, sessionId: sessionId },
    token
  );
};

export const GetRequestToProvider = async (orderNr: string, verifyMethod: string): Promise<any> => {
  return await easyfyAxios.get(`/api/ageverification?handler=requestToProvider&orderNr=${orderNr}&verifyMethod=${verifyMethod}&?n=${new Date().getTime()}`);
};
